import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "../StatusCard";
import { MetricCard } from "../MetricCard";
import { QueryStateBoundary } from "../QueryStateBoundary";
import { useVersion, useBuildInfo } from "@/hooks/queries/useSystemInfo";

interface VersionPayload {
  data: {
    application_version: string;
    git_commit: string;
  };
}

interface BuildInfoPayload {
  data: {
    build_version: string;
  };
}

export function SystemInformationSection(): React.JSX.Element {
  const versionQuery = useVersion();
  const buildInfoQuery = useBuildInfo();

  return (
    <StatusCard title="System Information">
      <Stack spacing={1.5}>
        <QueryStateBoundary query={versionQuery}>
          {(payload) => {
            const version = payload as unknown as VersionPayload;
            return (
              <>
                <MetricCard label="Backend Release" value={version.data?.application_version} />
                <MetricCard label="Git Version" value={version.data?.git_commit} />
              </>
            );
          }}
        </QueryStateBoundary>
        <QueryStateBoundary query={buildInfoQuery}>
          {(payload) => {
            const build = payload as unknown as BuildInfoPayload;
            return <MetricCard label="API Version" value={build.data?.build_version} />;
          }}
        </QueryStateBoundary>
        {/* Neither /system/version nor /system/build reports a distinct
            "architecture version" concept today — reporting that honestly
            rather than fabricating one. */}
        <MetricCard label="Architecture Version" value={null} />
      </Stack>
    </StatusCard>
  );
}
